import React, { Component } from "react";
import T from "prop-types";
import { connect } from "react-redux";
import { change, formValueSelector } from "redux-form";
import classNames from "classnames";
import { selectPrimaryContact } from "MODULES/companies/helpers";
import { COMPANY_ID, CONTACT_ID, NAME } from "APP_ROOT/constants";
import { searchContacts } from "MODULES/parts/actions/actions";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { COMPANY, CONTACT } from "MODULES/companies/constants";
import { Col } from "react-bootstrap";
import RestrictedEntityWarning from "MODULES/companies/shared/components/RestrictedEntityWarning";
import CreateCompany from "./CreateCompany";
import SearchCompany from "./SearchCompany";

class FormToggle extends Component {
  static propTypes = {
    allowPortalPurchase: T.bool,
    clearCompany: T.func.isRequired,
    clearCompanyId: T.func.isRequired,
    companySearch: T.func,
    onCompanySelected: T.func,
    setPrimaryContact: T.bool
  };

  static defaultProps = {
    onCompanySelected: () => {},
    setPrimaryContact: true
  };

  state = {
    companyToggleType: "existing",
    selectedCompany: null,
    contacts: []
  };

  handleExistingCompanyClick = ev => {
    this.props.clearCompany();
    this.setState({ companyToggleType: "existing" });
    ev.preventDefault();
  };

  handleNewCompanyClick = ev => {
    ev.preventDefault();
    this.setState({
      companyToggleType: "new",
      selectedCompany: null,
      contacts: []
    });
    this.props.clearCompany();
    this.props.onCompanySelected(null);
  };

  handleCompanySelected = company => {
    this.setState({ selectedCompany: company });
    this.props.onCompanySelected(company);

    if (company) {
      this.fetchContacts(company.id);
    } else {
      this.setState({ contacts: [] });
    }
  };

  fetchContacts = value => {
    if (!value) {
      return null;
    }

    return searchContacts(value).then((vals = []) => {
      this.setState({ contacts: vals });
      if (this.props.setPrimaryContact) {
        selectPrimaryContact(
          vals,
          this.props.setFieldValue(CONTACT_ID),
          this.handleEmail
        );
      }
    });
  };

  handleEmail = email => {
    if (this.props.handleEmail) {
      this.props.handleEmail(email);
    }
  };

  render() {
    const { allowPortalPurchase, getFieldValue } = this.props;
    const { companyToggleType, selectedCompany } = this.state;
    const activeExisting = classNames("btn btn-default", {
      active: companyToggleType === "existing"
    });
    const activeNew = classNames("btn btn-default", {
      active: companyToggleType === "new"
    });

    return (
      <div>
        <FormRow>
          <Col md={9}>
            <div className="form-group" style={{ marginBottom: 20 }}>
              <div className="btn-group btn-group-justified" role="group">
                <div className="col-md-6" style={{ padding: 0, margin: 0 }}>
                  <button
                    className={activeExisting}
                    onClick={this.handleExistingCompanyClick}
                    type="button"
                    style={{ width: "100%" }}
                  >
                    <i className="fa fa-lg fa-check-circle" />
                    &nbsp;&nbsp;Choose Existing Company
                  </button>
                </div>
                <div className="col-md-6" style={{ padding: 0, margin: 0 }}>
                  <button
                    className={activeNew}
                    type="button"
                    onClick={this.handleNewCompanyClick}
                    style={{ width: "100%" }}
                  >
                    <i className="fa fa-lg fa-check-circle" />
                    &nbsp;&nbsp;Create New Company
                  </button>
                </div>
              </div>
            </div>
          </Col>
        </FormRow>
        <div>
          {companyToggleType === "existing" ? (
            <SearchCompany
              {...this.props} // overrides companySearch api call here if defined
              selectedCompany={selectedCompany}
              contacts={this.state.contacts}
              fetchContacts={this.fetchContacts}
              onCompanySelected={this.handleCompanySelected}
              handleEmail={this.handleEmail}
            />
          ) : (
            <CreateCompany
              getFieldValue={getFieldValue}
              handleEmail={this.handleEmail}
              allowPortalPurchase={allowPortalPurchase}
            />
          )}
        </div>
        <FormRow>
          <Col md={12}>
            <RestrictedEntityWarning
              company={selectedCompany}
              name={getFieldValue(`${COMPANY}.${NAME}`)}
              contactId={getFieldValue(CONTACT_ID)}
            />
          </Col>
        </FormRow>
      </div>
    );
  }
}

export default connect(
  (state, ownProps) => ({
    getFieldValue: field => formValueSelector(ownProps.formName)(state, field)
  }),
  (dispatch, ownProps) => ({
    clearCompany: () => {
      dispatch(change(ownProps.formName, COMPANY, {}));
      dispatch(change(ownProps.formName, CONTACT, {}));
      dispatch(change(ownProps.formName, COMPANY_ID, null));
      dispatch(change(ownProps.formName, CONTACT_ID, null));
    },
    clearCompanyId: () => {
      dispatch(change(ownProps.formName, COMPANY, {}));
      dispatch(change(ownProps.formName, CONTACT, {}));
      dispatch(change(ownProps.formName, COMPANY_ID, null));
      dispatch(change(ownProps.formName, CONTACT_ID, null));
    },
    clearNewContact: () => {
      dispatch(change(ownProps.formName, CONTACT, {}));
    },
    setFieldValue: field => val =>
      dispatch(change(ownProps.formName, field, val))
  })
)(FormToggle);



// WEBPACK FOOTER //
// ./app/modules/companies/shared/FindOrCreateCompanyToggle/FormToggle.jsx